import React, { useState } from 'react';
import PersianNumberInput from './Input';

export default function BodyFatCalculator() {
  const [gender, setGender] = useState('female');
  const [neck, setNeck] = useState('');
  const [waist, setWaist] = useState('');
  const [hip, setHip] = useState('');
  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');
  const [age, setAge] = useState('');
  const [results, setResults] = useState(null);

  const calculate = () => {
    const n = parseFloat(neck);
    const w = parseFloat(waist);
    const h = parseFloat(height);
    const hp = parseFloat(hip);
    const wt = parseFloat(weight);
    const a = parseFloat(age);

    if (!n || !w || !h) {
      setResults(null);
      return;
    }

    let navy = null;
    if (gender === 'male') {
      navy =
        495 / (1.0324 - 0.19077 * Math.log10(w - n) + 0.15456 * Math.log10(h)) -
        450;
    } else {
      navy =
        495 /
          (1.29579 - 0.35004 * Math.log10(w + hp - n) + 0.221 * Math.log10(h)) -
        450;
    }

    let deurenberg = null;
    if (wt && a) {
      const bmi = wt / Math.pow(h / 100, 2);
      const sex = gender === 'male' ? 1 : 0;
      deurenberg = 1.2 * bmi + 0.23 * a - 10.8 * sex - 5.4;
    }

    // clamp to 2–70% range
    const clamp = (val) => Math.min(70, Math.max(2, val));

    const withRange = (val) => {
      if (val == null || isNaN(val)) return null;
      const low = clamp(val - 1).toFixed(1);
      const high = clamp(val + 1).toFixed(1);
      return `${low}% – ${high}%`;
    };

    setResults({
      navy: withRange(navy),
      deurenberg: withRange(deurenberg),
    });
  };

  return (
    <div>
      <h2>Body Fat Estimator</h2>
      <div>
        <label>Gender:</label>
        <select value={gender} onChange={(e) => setGender(e.target.value)}>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>

      <div>
        <label>Neck (cm):</label>

        <input
          type="number"
          value={neck}
          onChange={(e) => setNeck(e.target.value)}
        />
      </div>
      <div>
        <label>Waist (cm):</label>
        <input
          type="number"
          value={waist}
          onChange={(e) => setWaist(e.target.value)}
        />
      </div>
      <div>
        <label>Hip (cm):</label>
        <input
          type="number"
          value={hip}
          onChange={(e) => setHip(e.target.value)}
        />
      </div>
      <div>
        <label>Height (cm):</label>
        <input
          type="number"
          value={height}
          onChange={(e) => setHeight(e.target.value)}
        />
      </div>
      <div>
        <label>Weight (kg):</label>
        <input
          type="number"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />
      </div>
      <div>
        <label>Age:</label>
        <input
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
        />
      </div>

      <button onClick={calculate}>Calculate</button>

      {results && (
        <div>
          <p>Navy estimate: {results.navy || 'N/A'}</p>
          <p>Deurenberg estimate: {results.deurenberg || 'N/A'}</p>
        </div>
      )}
    </div>
  );
}
